import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, Icon, Dropdown } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { TRANSLATION_FILES } from './../constants/translation';

class SearchFilter extends Component {
  static propTypes = {
    filterName: PropTypes.string.isRequired,
    filterInName: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onSearchInChange: PropTypes.func,
    onClear: PropTypes.func.isRequired,
    search: PropTypes.string,
    searchIn: PropTypes.string,
    placeholder: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object),
    isFullSize: PropTypes.bool,
    t: PropTypes.func,
  }
  static defaultProps = {
    filterName: 'search',
    filterInName: 'searchIn',
    isLoading: false,
    placeholder: 'Search',
  }
  static getPropsToState = (props) => {
    const search = props.search || '';
    let searchIn = props.searchIn || '';
    if (props.options && props.options.length > 0 && (!searchIn || searchIn === '')) {
      searchIn = props.options[0].value;
    }
    return {
      search,
      searchIn,
    };
  }
  constructor(props) {
    super(props);
    const state = SearchFilter.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = SearchFilter.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleClear = () => {
    this.setState({ search: '' }, () => {
      const { onClear, filterName } = this.props;
      if (onClear) {
        onClear(filterName);
      }
    });
  }
  handleSearch = (e) => {
    if (e) { e.preventDefault(); }
    if (this.state.search === '' && this.props.search !== '') {
      this.handleClear();
    } else if (this.state.search) {
      this.props.onChange(this.state.search, this.props.filterName);
    }
  }
  handleOnChange = (e) => {
    const search = e.target.value;
    this.setState({ search }, () => {
      if (search === '') {
        this.handleClear();
      }
    });
  }
  handleOnDropdownChange = (e, { value }) => {
    this.setState({ searchIn: value }, () => {
      this.props.onSearchInChange(value, this.props.filterInName);
    });
  }
  render() {
    const { t } = this.props;
    return (
      <form onSubmit={this.handleSearch} className="search-in">
        <Input
          fluid
          icon={
            this.state.search ?
              <Icon
                className="clear-button"
                color="teal"
                link
                name="x"
                onClick={this.handleClear}
                title={t('Clear input')}
              />
            : null
          }
          loading={this.props.isLoading}
          disabled={this.props.isLoading}
          name="search"
          onChange={this.handleOnChange}
          placeholder={t(this.props.placeholder)}
          value={this.state.search}
        />
        {
          this.props.options && this.props.options.length > 0 &&
          <Dropdown
            className={this.props.isFullSize ? 'small' : null}
            fluid
            selection
            onChange={this.handleOnDropdownChange}
            options={this.props.options}
            disabled={this.props.isLoading}
            value={this.state.searchIn}
          />
        }
        <button
          type="submit"
          className="ui icon right attached button search"
          disabled={this.props.isLoading}
          title={t('Search')}
        >
          <Icon name="search" />
        </button>
      </form>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens)(SearchFilter);



// WEBPACK FOOTER //
// ./src/components/SearchIn.jsx